import type { HelpFile } from '../../types/help'
import { AccessRequestWizardTestIds } from '../../../testids/AccessRequestWizardTestIds'

export const accessRequestWizardHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [AccessRequestWizardTestIds.accessRequestWizardPage]:
      'Schritt-für-Schritt-Assistent für Zugriffsanfragen. Empfänger wählen, ein oder mehrere Zugriffsprofile auswählen, dann prüfen und absenden. Nach dem Absenden startet der Genehmigungs-Workflow.',
    [AccessRequestWizardTestIds.accessRequestStepContainer]: null,
    [AccessRequestWizardTestIds.cardTitleWhoNeedsAccess]:
      'Erster Schritt — wählen, ob die Anfrage für Sie selbst oder für eine andere Person ist.',
    [AccessRequestWizardTestIds.cardTitleSelectAccessProfiles]:
      'Zweiter Schritt — ein oder mehrere Zugriffsprofile zur Anfrage hinzufügen. Jedes Profil bündelt zusammengehörige Berechtigungen und Zielsystemzugriffe.',
    [AccessRequestWizardTestIds.cardTitleReviewAndSubmit]:
      'Letzter Schritt — Empfänger und gewählte Zugriffsprofile vor dem Absenden zur Genehmigung prüfen.',
    [AccessRequestWizardTestIds.btnSelectMyself]:
      'Zugriff für die eigene Identität beantragen.',
    [AccessRequestWizardTestIds.btnSelectSomeoneElse]:
      'Zugriff im Namen einer anderen Identität beantragen — in der Regel für Vorgesetzte.',
    [AccessRequestWizardTestIds.accessProfileAssociationEditor]:
      'Zugriffsprofile suchen und für diesen Antrag auswählen.',
    [AccessRequestWizardTestIds.reviewProfileItem]:
      'Zugriffsprofil, das in diesen Antrag aufgenommen wurde — sichtbar in der Zusammenfassung vor dem Absenden.',
    [AccessRequestWizardTestIds.beneficiaryMultiPicker]:
      'Identitäten suchen — bis zu 50 Begünstigte auswählen. Ausgewählte Identitäten erscheinen oben als Chips.',
    [AccessRequestWizardTestIds.beneficiaryCounter]:
      'Live-Zähler der ausgewählten Begünstigten. Bei 49 wird der Zähler bernsteinfarben, bei der 50er-Grenze rot. Die Auswahl ist bei 50 deaktiviert — Chip entfernen, um wieder zu ergänzen.',
    [AccessRequestWizardTestIds.beneficiaryCapMessage]:
      'Die 50er-Grenze ist erreicht. Entferne einen Chip, um die Auswahl wieder zu aktivieren.',
    [AccessRequestWizardTestIds.reviewBeneficiaryChips]:
      'Alle Empfänger dieser Einreichung, aufgelistet nach Anzeigename.',
    [AccessRequestWizardTestIds.reviewExpansionSummary]:
      'Gesamtberechnung: wie viele Zugriffsanfragen erstellt werden — Begünstigte × Zugriffsprofile.',
    [AccessRequestWizardTestIds.btnPreviousStep]: null,
    [AccessRequestWizardTestIds.btnNextStep]: null,
    [AccessRequestWizardTestIds.btnSubmitRequest]:
      'Antrag zur Genehmigung absenden — Fortschritt unter „Meine Anfragen” verfolgen.',
    [AccessRequestWizardTestIds.btnCancel]: null,
  },
}
